import { RevenueShareType } from 'src/api';
import {
  ChangeEmployerBillingFormFields,
  ChangeVerifierBillingFormFields,
} from 'src/types/billing';

import { ChangeEmployerBillingFormValues, ChangeVerifierBillingFormValues } from '../types';

export const getChangeEmployerBillingInitialValues = (
  revenueShare?: number | undefined,
  revenueShareType?: RevenueShareType,
): ChangeEmployerBillingFormValues => ({
  [ChangeEmployerBillingFormFields.revenueShareValue]: revenueShare || 0,
  [ChangeEmployerBillingFormFields.revenueShareType]: revenueShareType || RevenueShareType.Flat,
});

export const getChangeVerifierBillingInitialValues = (
  voe?: number | undefined,
  voi?: number | undefined,
  reverification?: number | undefined,
): ChangeVerifierBillingFormValues => ({
  [ChangeVerifierBillingFormFields.voe]: voe || 0,
  [ChangeVerifierBillingFormFields.voi]: voi || 0,
  [ChangeVerifierBillingFormFields.reverification]: reverification || 0,
});
